<template>
  <v-row 
    class="d-flex text-body-2 justify-center pr-0 mt-13 mb-12 mx-9"
    style="border: 4px dashed #999; border-radius: 8px;" 
  >
    <v-col cols="10">
      <span>Después de especificar los detalles relevantes en este cuadro, los datos podrán ser integrados y analizados mediante el TraceDiag (Rastreador de Diagnósticos), para explorar posibles coincidencias diagnósticas y brindar algunas hipótesis diagnósticas iniciales.</span>
    </v-col>
    <v-col cols="1" class="d-flex mr-12 align-center">
      <v-btn small dark primary1 @click.stop="dialog = true">
        TraceDiag
      </v-btn>
      <v-dialog
        v-model="dialog"
        width="100%"
        transition="dialog-bottom-transition"
        persistent
        content-class="trace-dialog-content"
      >
        <v-card
          class="rounded-t-xl trace-card"
          style="height: 100%"
        >
          <v-toolbar
            dark
            color="primary"
            height="30px"
            class="justify-end"
          >
            <v-btn
              icon
              small
              dark
              @click="dialog = false"
              class="ml-auto mr-1"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-row  class="mx-2">
            <v-card-title class="text-subtitle-1 pt-7 pb-2 justify-center">RASTREADOR DE DIAGNÓSTICOS</v-card-title>
            <v-card-text>Esta herramienta permite evaluar los detalles de los síntomas y los relaciona con distintos trastornos para estimar cuáles podrían tener mayor probabilidad de ser el diagnóstico.
              <br> Antes de rastrear es importante completar el cuadro de detalles de los sintomas, caso contrario puedes marcar la casilla para que se ejecute sin considerar el cuadro anterior.
            </v-card-text>
            <span class="text-caption mt-1 ml-4">Rastrear SIN utilizar los Detalles de los Síntomas: </span>
            <v-checkbox
              :input-value="checkboxDS"
              @change="handleEventsbox"
              hide-details
              class="mt-0 pt-0 ml-2"
            ></v-checkbox>
          </v-row>
          <v-row justify="center" class="mx-2 mt-2 mb-5">
            <v-btn 
              dark 
              primary1
              class="ma-2" 
              @click="traceDiagBtn"
            >
              Rastrear
            </v-btn>
          </v-row>

          <v-row class="d-flex flex-wrap">
            <v-col cols="12" sm="12" lg="6" class="mt-5">
              <v-data-table
                :headers="headersCodeT"
                :items="dataCodeT"
                class="elevation-1 mx-7 trace-diag-table2 mini-font"
                dense
                hide-default-footer
                :items-per-page="-1"
                height="100%"
              >
              </v-data-table>
            </v-col>
          </v-row>

          <v-row class="mx-7 mt-5">
            <v-col cols="12">
              <div class="text-subtitle-1 font-weight-bold mb-3 grey--text text--darken-3">
                Rangos de Compatibilidad Diagnóstica
              </div>
              
              <v-row>
                <v-col cols="12" md="6" class="py-2">
                  <div class="pa-3 rounded elevation-1 fill-height" style="border-left: 5px solid #757575; background-color: #f5f5f5;">
                    <div class="font-weight-bold grey--text text--darken-3 mb-1">
                      Subclínico (0% - 49%)
                    </div>
                    <div class="text-caption text-justify grey--text text--darken-2">
                      La sintomatología presente es insuficiente para alcanzar el umbral clínico del trastorno. Los síntomas pueden ser leves, aislados o inespecíficos y no evidencian un deterioro funcional significativo atribuible al cuadro evaluado.
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="py-2">
                  <div class="pa-3 rounded elevation-1 fill-height" style="border-left: 5px solid #FFC107; background-color: #FFFDE7;">
                    <div class="font-weight-bold amber--text text--darken-4 mb-1">
                      Sospecha Clínica (50% - 69%)
                    </div>
                    <div class="text-caption text-justify grey--text text--darken-2">
                      Se observa un conjunto de síntomas compatible con el trastorno, aunque los criterios diagnósticos aún no se cumplen en su totalidad. Se recomienda realizar una evaluación clínica más profunda y considerar diagnósticos diferenciales, así como el seguimiento de la evolución del cuadro.
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="py-2">
                  <div class="pa-3 rounded elevation-1 fill-height" style="border-left: 5px solid #FF9800; background-color: #FFF3E0;">
                    <div class="font-weight-bold orange--text text--darken-4 mb-1">
                      Riesgo Alto (70% - 84%)
                    </div>
                    <div class="text-caption text-justify grey--text text--darken-2">
                      La presentación clínica muestra una elevada probabilidad de corresponder al trastorno evaluado. La mayor parte de los criterios diagnósticos está presente, aunque aún puede faltar información clínica o criterios específicos para establecer un diagnóstico plenamente compatible. Se recomienda una valoración diagnóstica integral.
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" md="6" class="py-2">
                  <div class="pa-3 rounded elevation-1 fill-height" style="border-left: 5px solid #F44336; background-color: #FFEBEE;">
                    <div class="font-weight-bold red--text text--darken-4 mb-1">
                      Trastorno Compatible (85% - 100%)
                    </div>
                    <div class="text-caption text-justify grey--text text--darken-2">
                      La sintomatología observada es altamente compatible con los criterios diagnósticos establecidos en el DSM-5 y/o la CIE-11. El cuadro alcanza el umbral clínico esperado para el trastorno evaluado, por lo que el diagnóstico debe ser considerado dentro de la formulación clínica, siempre integrado con el juicio profesional, la entrevista clínica y otras fuentes de información.
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col>
      <span class="d-flex text-caption ml-4 justify-start">Nota: No reemplaza la valoración profesional, es un recurso de apoyo para orientar el análisis clínico.</span>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'VDialogTraceDiag',
  props: ['dialogTraceDiag', 'traceDiagBtn', 'headersGroupsT', 'dataGroupsT', 'headersCodeT', 'dataCodeT', 'checkboxDS', 'handleEventsbox'],
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
};
</script>

<style>
.position-relative {
  position: relative;
}

/* Centrar/pegar el diálogo al fondo de la pantalla */
.trace-dialog-content {
  width: 100%;
  max-width: 98%;
  height: 100vh;           /* Ocupa todo el alto de la ventana */
  max-height: 100vh;
  overflow-y: auto;
  border-radius: 12px 12px 0 0;
  margin: 0;
  margin-top: 8rem;
}

/* Card: límite de alto y scroll interno */
.trace-card {
  width: 100%;
  overflow-y: auto;       /* el scroll será DENTRO del card */
  border-radius: 12px 12px 0 0;
}

/* Ocultar barras de scroll (Webkit, Firefox, IE/Edge) */
/* Aplicado a la card y al contenedor del diálogo (overlay) */
.trace-card::-webkit-scrollbar,
.trace-dialog-content::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}
.trace-card,
.trace-dialog-content {
  -ms-overflow-style: none; /* IE/Edge */
  scrollbar-width: none;    /* Firefox */
}

/* Cuando Vuetify bloquea el scroll del body, aseguramos overflow hidden */
.v-overlay-scroll-blocked {
  overflow: hidden !important;
}

.trace-diag-table .v-data-table__wrapper td,
.trace-diag-table .v-data-table__wrapper th {
  font-size: 12px !important; 
  line-height: 1;  
  padding: 1px 7px 1px 7px !important; 
  margin: 0px !important;        
  text-align: center !important;
}

.trace-diag-table .v-data-table__wrapper td:nth-child(3),
.trace-diag-table .v-data-table__wrapper th:nth-child(3) {
  font-size: 12px !important; 
  line-height: 1;  
  padding: 1px 7px 1px 7px !important; 
  margin: 0px !important;        
  text-align: left !important;
}

.trace-diag-table2 .v-data-table__wrapper td,
.trace-diag-table2 .v-data-table__wrapper th {
  font-size: 12px !important; 
  line-height: 1;  
  padding: 1px 7px 1px 7px !important; 
  margin: 0px !important;        
  text-align: center !important;
}

.trace-diag-table2 .v-data-table__wrapper td:nth-child(2),
.trace-diag-table2 .v-data-table__wrapper th:nth-child(2) {
  font-size: 12px !important; 
  line-height: 1;  
  padding: 1px 7px 1px 7px !important; 
  margin: 0px !important;        
  text-align: left !important;
}
</style>
